/**
 * Working paper codes whose save spans audit + account (Feign).
 * Keep in sync with backend WpCrossServiceCodes.
 */
export const WP_CROSS_SERVICE_CODES = new Set([
  'BS-EQ-IC',
  'BS-CA-CASH',
  'BS-CL-BOD',
  'BS-EQ-DIV',
  'PL-TURN-SI',
  'PL-TURN-SE',
  'PL-TAX',
]);

export function requiresWpGlobalTx(code?: string | null): boolean {
  if (!code) return false;
  return WP_CROSS_SERVICE_CODES.has(code.trim().toUpperCase());
}
